const freezeScrollPosition = () => {
  const initialScrollY = window.scrollY;
  const viewportHeight = window.innerHeight;
  const documentHeight = document.body.scrollHeight;

  return { initialScrollY, viewportHeight, documentHeight };
};

const adjustScrollPosition = (initialState: {
  initialScrollY: number;
  viewportHeight: number;
  documentHeight: number;
}) => {
  const currentDocumentHeight = document.body.scrollHeight;
  const heightDifference = currentDocumentHeight - initialState.documentHeight;

  if (heightDifference !== 0) {
    window.scrollTo({
      top: initialState.initialScrollY + heightDifference,
      behavior: "auto",
    });
  }
};

export const handleContentUpdate = (contentUpdateCallback: () => void) => {
  document.documentElement.style.scrollBehavior = "auto";
  const initialScrollState = freezeScrollPosition();
  contentUpdateCallback();
  requestAnimationFrame(() => {
    adjustScrollPosition(initialScrollState);
    requestAnimationFrame(() => {
      document.documentElement.style.scrollBehavior = "smooth";
    });
  });
};
